import { PageRouteBuilder } from "@common/route/page-route-builder";
import { ConfigureOrganisationFeaturesComponent } from "./configure-organisation-features.component";

export const configureOrganisationFeaturesRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-configure-organisation-features", ConfigureOrganisationFeaturesComponent)
    .requiresLogin()
    .atUrl("/tools/configureOrganisationFeatures")
    .withTitle("Configure Organisation Features")
    .build();
